import React, { Component } from "react";
import MainHeader from "../Header/header";
import HeaderContainer from "../Header/LandingHeader/HeaderContainer";
import { Row, Col, Card, Button, Checkbox, message } from "antd";
import { ColShadow } from "../Constants/style";
import { Link } from "react-router-dom";
import { Parse } from "parse";

class Purchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // checked1: false,
      checked2: false,
      checked3: false,
      // checked4: false,
      checked5: false,
      fees: true,
      // subscribe1: 150,
      subscribe2: 79,
      subscribe3: 59,
      // subscribe4: 60,
      subscribe5: 49,
      diet1: 40,
      diet2: 30
    };
  }

  async componentDidMount() {
    try {
      this.currentUser = await Parse.User.current().fetch();
      if (this.currentUser === null || this.currentUser === undefined) {
        this.setState({ redirectToHomePage: true });
        return message.warn("Ta session a expiré, reconnecte-toi !");
      }
      if (this.currentUser.attributes !== undefined) {
        this.setState({ attributes: this.currentUser.attributes });
      }
    } catch (error) {
      console.log("error : ", error);
      if (error.code === 209 || error.message === "invalid session token") {
        console.log("invalid session token");
        this.props.userDisconnected();
        this.setState({ redirectToHomePage: true });
        return message.warn("Ta session a expiré, reconnecte-toi !");
      }
    }
  }

  handleFees = e => {
    this.setState({ fees: !e.target.checked });
  };

  handleCheck2 = () => {
    const tarif = 79;
    if (this.state.checked2 === false) {
      this.setState({ checked2: true });
      this.setState({ subscribe2: (tarif + 30) });
    }
    if (this.state.checked2 === true) {
      this.setState({ checked2: false });
      this.setState({ subscribe2: tarif });
    }
  };

  handleCheck3 = () => {
    const tarif = 59;
    if (this.state.checked3 === false) {
      this.setState({ checked3: true });
      this.setState({ subscribe3: (tarif + 30) });
    }
    if (this.state.checked3 === true) {
      this.setState({ checked3: false });
      this.setState({ subscribe3: 59 });
    }
  };

  handleCheck5 = () => {
    const tarif = 49;
    if (this.state.checked5 === false) {
      this.setState({ checked5: true, subscribe5: (tarif + 30) });
    }
    if (this.state.checked5 === true) {
      this.setState({ checked5: false, subscribe5: tarif });
    }
  };

  purchaseOptions = () => {
    var user = Parse.User.current();
    if (user.attributes.professional === true) {
      return (
        <Row type="flex" justify="center" align="middle">
          <Col
            style={{ marginBottom: "35px", marginTop: "50px" }}
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <ColShadow
              style={{
                backgroundColor: "#fff",
                padding: "10px",
                marginTop: "2%",
                marginBottom: "1.5%"
              }}
              align="middle"
            >
              <h4>
                Abonnement / Renouvellement de Licence Coach Urban Fitness
              </h4>
            </ColShadow>
            <Card
              style={{ padding: "25px" }}
              bordered={true}
              cover={
                <img
                  alt="licence1"
                  src={require("../img/creditcard.png")}
                  style={{ height: 64, width: 64, marginLeft: "25px" }}
                />
              }
            >
              <h4>LICENCE COACH</h4>
              <div
                style={{
                  height: "3px",
                  width: "40%",
                  background: "#5A9CA6",
                  marginTop: "15px",
                  marginBottom: "25px"
                }}
              />
              <p style={{ color: "#969696", fontWeight: "bold" }}>
                Avant tout achat/renouvellement de licence, veillez à vous
                entretenir avec Sarah afin de confirmer votre statut de coach et
                votre souscription à Urban Fitness
              </p>
              <div
                style={{
                  height: "1px",
                  width: "100%",
                  background: "#c5c5c5",
                  marginTop: "20px",
                  marginBottom: "20px"
                }}
              />
              <Row type="flex" justify="space-between">
                <p style={{ fontWeight: "600", fontSize: 18, color: "#000" }}>
                  500€/an
                </p>
                <Link
                  to={{
                    pathname: "/payment",
                    state: {
                      price: 500,
                      label: "Licence Coach Urban Fitness",
                      duration: 0.01,
                      couponApplied: false
                    }
                  }}
                >
                  <Button type="primary">Sélectionner</Button>
                </Link>
              </Row>
              <Row type="flex" justify="space-between" align="start">
                <p style={{ fontWeight: "600", fontSize: 18, color: "#000" }}>
                  50€/mois
                </p>
                <Link
                  to={{
                    pathname: "/payment",
                    state: {
                      price: 50,
                      label: "Licence Coach Urban Fitness",
                      duration: 12,
                      coach: true,
                      couponApplied: false
                    }
                  }}
                >
                  <Button type="primary">Sélectionner</Button>
                </Link>
              </Row>
            </Card>
          </Col>
        </Row>
      );
    } else {
      return (
        <div style={{padding:'1em'}}>
          <Row type="flex" justify="space-around">
            <Col
              style={{ marginBottom: "35px" }}
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={4}
            >
              <Card
                style={{ paddingTop: "25px", height: "500px" }}
                bordered={true}
                cover={
                  <img
                    alt="coaching1"
                    src={require("../img/creditcard.png")}
                    style={{ height: 64, width: 64, marginLeft: "25px" }}
                  />
                }
              >
                <h4>SÉANCE URBAN'ADDICT</h4>
                <div
                  style={{
                    height: "3px",
                    width: "40%",
                    background: "#5A9CA6",
                    marginTop: "15px",
                    marginBottom: "25px"
                  }}
                />
                <div style={{ marginTop: "10%", marginBottom: "10%" }} />
                <div
                  style={{
                    height: "1.25px",
                    width: "100%",
                    background: "#c5c5c5",
                    marginTop: "175px",
                    marginBottom: "20px"
                  }}
                />
                <Row type="flex" justify="space-between">
                  <p style={{ fontWeight: "600", fontSize: 18, color: "#000" }}>
                    15 €
                  </p>
                </Row>
                <Row>
                  <Link
                    to={{
                      pathname: "/payment",
                      state: {
                        price: 15,
                        label: "Séance Urban'Addict",
                        quantity: "x1",
                        duration: 0.1,
                        couponApplied: false
                      }
                    }}
                  >
                    <Button type="primary">Sélectionner</Button>
                  </Link>
                </Row>
              </Card>
            </Col>
            {/* 3 MOIS */}
            <Col
              style={{ marginBottom: "35px" }}
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={4}
            >
              <Card
                style={{ paddingTop: "25px", height: "500px" }}
                bordered={true}
                cover={
                  <img
                    alt="abonnement2"
                    src={require("../img/creditcard.png")}
                    style={{ height: 64, width: 64, marginLeft: "25px" }}
                  />
                }
              >
                <h4>3 MOIS</h4>
                <div
                  style={{
                    height: "3px",
                    width: "40%",
                    background: "#5A9CA6",
                    marginTop: "15px",
                    marginBottom: "25px"
                  }}
                />
                <Row
                  type="flex"
                  justify="space-between"
                  style={{ marginTop: "5%", marginBottom: "5%" }}
                >
                  <Col xs={20}>
                    <p style={{ color: "#969696" }}>Option diététicien</p>
                    <p style={{ color: "#969696" }}>
                      + {this.state.diet2}€/mois
                    </p>
                  </Col>
                  <Col xs={1} offset={3}>
                    <Checkbox
                      onChange={this.handleCheck2}
                      checked={this.state.checked2}
                    />
                  </Col>

                  <Col xs={20}>
                    <p style={{ color: "#969696" }}>
                      Cliquez cette case s'il s'agit d'un réabonnement
                    </p>
                  </Col>
                  <Col xs={1} offset={3}>
                    <Checkbox onChange={this.handleFees} />
                  </Col>
                </Row>
                <Row type="flex" justify="space-between" align="bottom">
                  <div
                    style={{
                      height: "1px",
                      width: "100%",
                      background: "#c5c5c5",
                      marginTop: "20px",
                      marginBottom: "20px"
                    }}
                  />
                  <Col xs={10} sm={10} md={24} lg={24} xl={24}>
                    <p
                      style={{ fontWeight: "500", fontSize: 18, color: "#000" }}
                    >
                      {this.state.subscribe2}€/mois
                    </p>
                  </Col>
                  <Col xs={12} sm={12} md={24} lg={24} xl={24}>
                    <Link
                      to={{
                        pathname: "/payment",
                        state: {
                          price: 79,
                          dietPrice: this.state.diet2,
                          finalPrice: this.state.subscribe2,
                          label: "Abonnement Urban'Addict - 3 mois",
                          quantity: "x1",
                          duration: 3,
                          diet: this.state.checked2,
                          couponApplied: false,
                          fees: this.state.fees
                        }
                      }}
                    >
                      <Button type="primary">Sélectionner</Button>
                    </Link>
                  </Col>
                </Row>
              </Card>
            </Col>
             {/* 6 MOIS */}
            <Col
              style={{ marginBottom: "35px" }}
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={4}
            >
              <Card
                style={{ paddingTop: "25px", height: "500px" }}
                bordered={true}
                cover={
                  <img
                    alt="abonnement1"
                    src={require("../img/creditcard.png")}
                    style={{ height: 64, width: 64, marginLeft: "25px" }}
                  />
                }
              >
                <h4>6 MOIS</h4>
                <div
                  style={{
                    height: "3px",
                    width: "40%",
                    background: "#5A9CA6",
                    marginTop: "15px",
                    marginBottom: "25px"
                  }}
                />
                <Row
                  type="flex"
                  justify="space-between"
                  style={{ marginTop: "5%", marginBottom: "5%" }}
                >
                  <Col xs={20}>
                    <p style={{ color: "#969696" }}>Option diététicien</p>
                    <p style={{ color: "#969696" }}>
                      + {this.state.diet2}€/mois
                    </p>
                  </Col>
                  <Col xs={1} offset={3}>
                    <Checkbox
                      onChange={this.handleCheck3}
                      checked={this.state.checked3}
                    />
                  </Col>
                  <Col xs={20}>
                    <p style={{ color: "#969696" }}>
                      Cliquez cette case s'il s'agit d'un réabonnement
                    </p>
                  </Col>
                  <Col xs={1} offset={3}>
                    <Checkbox onChange={this.handleFees} />
                  </Col>
                </Row>
                <Row type="flex" justify="space-between" align="bottom">
                  <div
                    style={{
                      height: "1px",
                      width: "100%",
                      background: "#c5c5c5",
                      marginTop: "20px",
                      marginBottom: "20px"
                    }}
                  />
                  <Col xs={10} sm={10} md={24} lg={24} xl={24}>
                    <p
                      style={{ fontWeight: "600", fontSize: 18, color: "#000" }}
                    >
                      {this.state.subscribe3}€/mois
                    </p>
                  </Col>
                  <Col xs={12} sm={12} md={24} lg={24} xl={24}>
                    <Link
                      to={{
                        pathname: "/payment",
                        state: {
                          price: 59,
                          dietPrice: this.state.diet2,
                          finalPrice: this.state.subscribe3,
                          label: "Abonnement Urban'Addict - 6 mois",
                          quantity: "x1",
                          duration: 6,
                          diet: this.state.checked3,
                          couponApplied: false,
                          fees: this.state.fees
                        }
                      }}
                    >
                      <Button type="primary">Sélectionner</Button>
                    </Link>
                  </Col>
                </Row>
              </Card>
            </Col>
             {/* 12 MOIS */}
            <Col
              style={{ marginBottom: "35px" }}
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={4}
            >
              <Card
                style={{ paddingTop: "25px", height: "500px" }}
                bordered={true}
                cover={
                  <img
                    alt="abonnement1"
                    src={require("../img/creditcard.png")}
                    style={{ height: 64, width: 64, marginLeft: "25px" }}
                  />
                }
              >
                <h4>12 MOIS</h4>
                <div
                  style={{
                    height: "3px",
                    width: "40%",
                    background: "#5A9CA6",
                    marginTop: "15px",
                    marginBottom: "25px"
                  }}
                />
                <Row
                  type="flex"
                  justify="space-between"
                  align="middle"
                  style={{ marginTop: "5%", marginBottom: "5%" }}
                >
                  <Col xs={20}>
                    <p style={{ color: "#969696" }}>Option diététicien</p>
                    <p style={{ color: "#969696" }}>
                      + {this.state.diet2}€/mois
                    </p>
                  </Col>
                  <Col xs={1} offset={3}>
                    <Checkbox
                      onChange={this.handleCheck5}
                      checked={this.state.checked5}
                    />
                  </Col>
                  <Col xs={20}>
                    <p style={{ color: "#969696" }}>
                      Cliquez cette case s'il s'agit d'un réabonnement
                    </p>
                  </Col>
                  <Col xs={1} offset={3}>
                    <Checkbox onChange={this.handleFees} />
                  </Col>
                </Row>
                <Row type="flex" justify="space-between" align="bottom">
                  <div
                    style={{
                      height: "1px",
                      width: "100%",
                      background: "#c5c5c5",
                      marginTop: "20px",
                      marginBottom: "20px"
                    }}
                  />
                  <Col xs={10} sm={10} md={24} lg={24} xl={24}>
                    <p
                      style={{ fontWeight: "600", fontSize: 18, color: "#000" }}
                    >
                      {this.state.subscribe5}€/mois
                    </p>
                  </Col>
                  <Col xs={12} sm={12} md={24} lg={24} xl={24}>
                    <Link
                      to={{
                        pathname: "/payment",
                        state: {
                          price: 49,
                          dietPrice: this.state.diet2,
                          finalPrice: this.state.subscribe5,
                          label: "Abonnement Urban'Addict - 1 an",
                          quantity: "x1",
                          duration: 12,
                          diet: this.state.checked5,
                          couponApplied: false,
                          fees: this.state.fees
                        }
                      }}
                    >
                      <Button type="primary">Sélectionner</Button>
                    </Link>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
         </div>
      );
    }
  };

  render() {
    return (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "#F0F2F5"
        }}
      >
        <MainHeader />
        <HeaderContainer />
        {this.purchaseOptions()}
      </div>
    );
  }
}

export default Purchase;
